import { createAsync, query, A } from "@solidjs/router";
import { For } from "solid-js";

import { runBatchGetCommand } from "~/_server/dynamoDB";
import { getByRowTypeServer } from "~/_server";
import { formattedTimestamp } from "~/lib";

const getAssessments = query( async () => {
	"use server";

	const MONTH_AGO = Math.floor( (Date.now() - ( 1000 * 60 * 60 * 24 * 35 )) / 1000 ); // in seconds

	const assessmentsData = await getByRowTypeServer( 'ASSESSMENT', 100, "pk, sk, #status, created", { '#status': 'status' }, undefined, false ).then( r => r?.items?.filter( a => a.created > MONTH_AGO ).sort( ( a, b ) => b.created - a.created ) ?? []	 );

	if ( !assessmentsData || !assessmentsData.length ) return [];

	const userMap = new Map<number, any>();
	for ( const a of assessmentsData ) {
		const userId = parseInt( a.pk.split( "#" )[1] );
		const existing = userMap.get( userId );

		// If we haven't seen this user, (attempts are in date order reverse)
		if ( !existing  ) {
			userMap.set( userId, {
				userId,
				started: a.created,
				status: a.status,
			} );
		}
	}

	const assessments = Array.from( userMap.values() );

	// Batch fetch profiles  based on unique IDs
	const ids = assessments.map( ua => ( {
		pk: `USER#${ua.userId}`,
		sk: `USER#${String( ua.userId ).padStart( 7, "0" )}`,
	} ) );
	
	const profiles = await runBatchGetCommand( ids, "userId, #name", { "#name": "name" } ).then( profiles => new Map( profiles?.map( p => [p.userId, p] ) ?? [] ) );

	return { assessments, profiles };

}, "getAssessments" );

export const RecentAssessments = () => {
	const data = createAsync( () => getAssessments() );

	return (
		<>
			<h2 class="text-xl text-black font-bold mb-4">Recent Assessments</h2>

			{/* 5. Loop over the unique user records instead */}
			<For each={data()?.assessments}>
				{( ua ) => {
					const userProfile = () => data()?.profiles?.get( ua.userId );

					return (
						<div class="p-3 bg-white rounded-lg shadow-sm mb-2 flex items-center justify-between">
							<div>
								<A class="text-sm font-semibold text-gray-900" href={`/dashboard/admin/users/${ua.userId}/assessments`}>
									{userProfile()?.name ?? `Loading user ${ua.userId}...`}
								</A>
								<p class="text-sm text-gray-500">
									Latest Attempt: {formattedTimestamp( ua.started )}
								</p>
							</div>
							<span
								class="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium capitalize"
								classList={{ [ua.status]: true }}
							>
								{ua.status}
							</span>
						</div>
					);
				}}
			</For>
		</>
	);
};